import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useLanguage } from '../../context/LanguageContext';
import styles from './SellerValueProp.module.css';

const SellerValueProp = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const { t } = useLanguage();

  const handleSellerCta = () => {
    navigate(isAuthenticated ? '/become-seller' : '/auth');
  };

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <h2 className={styles.heading}>{t('home.valueProp.heading')}</h2>
        <p className={styles.subheading}>{t('home.valueProp.subheading')}</p>

        <div className={styles.grid}>
          {/* Satici karti */}
          <div className={`${styles.card} ${styles.cardSeller}`}>
            <div className={styles.iconWrap}>
              <span className={styles.icon} role="img" aria-label="Yazıcı">🖨️</span>
            </div>
            <h3 className={styles.cardTitle}>
              {t('home.valueProp.sellerTitle')}
            </h3>
            <p className={styles.cardDesc}>
              {t('home.valueProp.sellerDesc')}
            </p>
            <ul className={styles.bullets}>
              <li>✓ {t('home.valueProp.sellerBullet1')}</li>
              <li>✓ {t('home.valueProp.sellerBullet2')}</li>
              <li>✓ {t('home.valueProp.sellerBullet3')}</li>
            </ul>
            <button
              type="button"
              className={styles.primaryBtn}
              onClick={handleSellerCta}
            >
              {isAuthenticated
                ? t('home.valueProp.sellerCtaAuth')
                : t('home.valueProp.sellerCtaGuest')}
            </button>
          </div>

          {/* Alici karti */}
          <div className={`${styles.card} ${styles.cardBuyer}`}>
            <div className={styles.iconWrap}>
              <span className={styles.icon} role="img" aria-label="Hediye">🎁</span>
            </div>
            <h3 className={styles.cardTitle}>
              {t('home.valueProp.buyerTitle')}
            </h3>
            <p className={styles.cardDesc}>
              {t('home.valueProp.buyerDesc')}
            </p>
            <ul className={styles.bullets}>
              <li>✓ {t('home.valueProp.buyerBullet1')}</li>
              <li>✓ {t('home.valueProp.buyerBullet2')}</li>
              <li>✓ {t('home.valueProp.buyerBullet3')}</li>
            </ul>
            <button
              type="button"
              className={styles.secondaryBtn}
              onClick={() => navigate('/marketplace')}
            >
              {t('home.valueProp.buyerCta')}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SellerValueProp;
